import React, { createContext, useContext } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastContext = createContext();
export const useToast = () => useContext(ToastContext);

export function ToastProvider({ children }) {
  // reusable toast wrappers
  const notifySuccess = (msg) =>
    toast.success(msg, {
      position: "bottom-right",
      autoClose: 2500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = (msg) =>
    toast.error(msg, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyInfo = (msg) =>
    toast.info(msg, {
      position: "bottom-right",
      autoClose: 2500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyWarning = (msg) =>
    toast.warning(msg, {
      position: "bottom-right",
      autoClose: 2500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });



 return (
  <ToastContext.Provider
    value={{ notifySuccess, notifyError, notifyInfo, notifyWarning }}
  >
    {children}
    {/* Append the container directly to document.body to escape z-index issues */}
   <ToastContainer
  position="bottom-right"
  autoClose={2500}
  newestOnTop
  theme="colored"
  closeOnClick
  pauseOnHover
  draggable
  toastStyle={{ zIndex: 999999 }}
/>

  </ToastContext.Provider>
);

}
